export default __webpack_public_path__ + "assets/e30b99dc82634cea1cdae8df27253e1c.png";